import { Sparkles, TrendingUp, Search } from "lucide-react";
import { getInsightBySlug } from "@/data/insights";

export const GeoVsSeoHeroSection = () => {
  const insight = getInsightBySlug("geo-vs-seo");
  
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-background via-background to-muted/30" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[600px] bg-primary/5 rounded-full blur-3xl" />
      <div className="absolute top-20 right-0 w-[400px] h-[400px] bg-purple-500/5 rounded-full blur-3xl" />
      
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 pt-8 sm:pt-12 pb-8">
        <div className="text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-gradient-to-r from-primary/10 to-purple-500/10 border border-primary/20 text-primary text-sm font-medium mb-5">
            <Sparkles className="w-4 h-4" />
            {insight?.tag}
          </div>
          
          <h1 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-foreground mb-4">
            <span className="bg-gradient-to-r from-primary via-purple-500 to-cyan-500 bg-clip-text text-transparent">GEO</span>
            {" "}vs{" "}
            <span className="text-foreground">SEO</span>
          </h1>
          <p className="text-lg sm:text-xl text-primary font-medium mb-4">
            {insight?.subtitle}
          </p>
          <p className="text-muted-foreground text-base sm:text-lg max-w-2xl mx-auto leading-relaxed mb-8">
            {insight?.description}
          </p>
          
          <div className="flex flex-wrap justify-center gap-6 sm:gap-10">
            <div className="text-center">
              <div className="flex items-center justify-center gap-2 text-2xl sm:text-3xl font-bold text-foreground">
                <Sparkles className="w-6 h-6 text-primary" />
                GEO
              </div>
              <div className="text-xs sm:text-sm text-muted-foreground">new ranking factor</div>
            </div>
            <div className="text-center">
              <div className="flex items-center justify-center gap-2 text-2xl sm:text-3xl font-bold text-foreground">
                <TrendingUp className="w-6 h-6 text-chart-2" />
                40%
              </div>
              <div className="text-xs sm:text-sm text-muted-foreground">search via AI</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};